module.exports = __webpack_public_path__ + "media/images/start_footer-92ea99c6cedce47473f3b7987650047f.webp";